export const format = strNum => {
  const num = parseFloat(strNum);
  const rounded = Math.round(num);
  return rounded === num ? num : `≈${rounded}`;
};

export const checkPortfolioMinValidations = (
  fund,
  taxableJointPortfolios,
  taxableIndividualPortfolios
) => {
  if (
    (taxableJointPortfolios || taxableIndividualPortfolios) &&
    !fund?.meetsMinimumInvestmentAmount
  ) {
    return fund.minimumInvestmentAmount;
  }
  if (!fund?.meetsAccountMinimumOpenIRA) {
    return fund.accountMinimumOpenIRA;
  }
  return '';
};
